import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect } from 'react';
import { getTestSelector } from '../../utilities/tests';
var RadioGroupContext = React.createContext({
    selected: undefined,
    setSelected: function () { },
    required: false,
});
var RadioGroup = function (_a) {
    var children = _a.children, className = _a.className, selected = _a.selected, setSelected = _a.setSelected, initialSelected = _a.initialSelected, groupId = _a.groupId, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.ContainerAs, ContainerAs = _c === void 0 ? 'div' : _c;
    useEffect(function () {
        if (initialSelected !== null && initialSelected !== undefined) {
            setSelected(initialSelected);
        }
    }, []);
    var contextValue = {
        selected: selected,
        setSelected: setSelected,
        required: required,
    };
    return (_jsx(ContainerAs, { id: groupId, className: className, "data-cy": getTestSelector(groupId, 'radio-group'), children: _jsx(RadioGroupContext.Provider, { value: contextValue, children: children }) }));
};
var Option = function (_a) {
    var id = _a.id, children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var context = React.useContext(RadioGroupContext);
    return (_jsx(_Fragment, { children: children(id === context.selected, !disabled
            ? function () {
                if (!context.required && id === context.selected) {
                    context.setSelected(null);
                }
                else {
                    context.setSelected(id);
                }
            }
            : function () { }) }));
};
var StyledOption = function (_a) {
    var id = _a.id, children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.testSelector, testSelector = _c === void 0 ? '' : _c;
    return (_jsx(RadioGroup.Option, { id: id, disabled: disabled, children: function (active, onClick) { return (_jsxs("div", { onClick: onClick, className: "flex items-center text-sm cursor-pointer", role: "radio", "data-public": "true", children: [_jsx("span", { className: clsx('inline-flex mr-1.5 w-4 h-4 border rounded-full transition-colors p-0.5 bg-zinc-50', disabled ? 'border-zinc-200' : 'border-zinc-400'), children: _jsx("span", { "aria-checked": active, "aria-disabled": disabled, "data-cy": "".concat(getTestSelector(testSelector)).concat(active ? '-active' : ''), className: clsx('rounded-full w-full h-full transition-colors', active && !disabled && 'bg-sky-500', active && disabled && 'bg-zinc-400') }) }), children] })); } }));
};
RadioGroup.Option = Option;
RadioGroup.StyledOption = StyledOption;
export { RadioGroup as default };
